import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

export default function ProfileGalleryHelpAccountPage() {
  const t = useTranslations('galleries_help.account');
  const [openSections, setOpenSections] = useState({
    editProfile: false,
    changePassword: false,
    galleryInformation: false,
    billingInformation: false,
    understandingActivity: false,
    modeAndTheme: false,
    currency: false,
    closedMode: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category gallery-help-category">
      <header className="artist-help-category__header gallery-help-category__header">
        <GoBackButton alternativeRoute="/profile/gallery-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body gallery-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('editProfile')}
            aria-expanded={openSections.editProfile}
          >
            <h2>{t('sections.edit_profile.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.editProfile ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.editProfile && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.edit_profile.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('changePassword')}
            aria-expanded={openSections.changePassword}
          >
            <h2>{t('sections.change_password.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.changePassword ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.changePassword && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.change_password.p1')}</p>
              <p>{t('sections.change_password.p2')}</p>
              <p>{t('sections.change_password.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('galleryInformation')}
            aria-expanded={openSections.galleryInformation}
          >
            <h2>{t('sections.gallery_information.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.galleryInformation ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.galleryInformation && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.gallery_information.p1')}</p>
              <p>{t('sections.gallery_information.p2_pre')} <a href="mailto:galleries@suarte.art">{t('sections.gallery_information.email')}</a>{t('sections.gallery_information.p2_post')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('billingInformation')}
            aria-expanded={openSections.billingInformation}
          >
            <h2>{t('sections.billing_information.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.billingInformation ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.billingInformation && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.billing_information.p1')}</p>
              <p>{t('sections.billing_information.p2')}</p>
              <p>{t('sections.billing_information.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('understandingActivity')}
            aria-expanded={openSections.understandingActivity}
          >
            <h2>{t('sections.understanding_activity.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.understandingActivity ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.understandingActivity && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.understanding_activity.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('modeAndTheme')}
            aria-expanded={openSections.modeAndTheme}
          >
            <h2>{t('sections.mode_and_theme.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.modeAndTheme ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.modeAndTheme && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.mode_and_theme.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('currency')}
            aria-expanded={openSections.currency}
          >
            <h2>{t('sections.currency.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.currency ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.currency && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.currency.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('closedMode')}
            aria-expanded={openSections.closedMode}
          >
            <h2>{t('sections.closed_mode.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.closedMode ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.closedMode && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.closed_mode.p1')}</p>
              <p>{t('sections.closed_mode.p2')}</p>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.closed_mode.how_to_use.title')}</h3>
                <p>{t('sections.closed_mode.how_to_use.p1')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.closed_mode.pending_sales.title')}</h3>
                <p>{t('sections.closed_mode.pending_sales.p1')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.closed_mode.limited_editions.title')}</h3>
                <p>{t('sections.closed_mode.limited_editions.p1')}</p>
              </div>

              <p>{t('sections.closed_mode.p3_pre')} <a href="mailto:galleries@suarte.art">{t('sections.closed_mode.email')}</a>{t('sections.closed_mode.p3_post')}</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
